export const BASE_URL = process.env.PUBLIC_URL || "";

export function url(relativePath = "") {
  if (!relativePath) return BASE_URL || "/";
  return `${BASE_URL}${relativePath.startsWith("/") ? "" : "/"}${relativePath}`;
}
